import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';

@Component({
    selector     : 'fading-loading-animation',
    templateUrl  : './fading-loading-animation.component.html',
    styleUrls    : ['./fading-loading-animation.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FadingLoadingAnimationComponent implements OnDestroy {

    /**
     * Constructor
     */
    constructor(
    ) {
    }

    ngOnDestroy(): void {
    }
}
